import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { isNilOrEmpty } from 'ramda-extension';

import { getCurrentNonProdEnv, isOnProd } from 'utils/routeHelper';

const Environment = () => {
	const currentEnv = getCurrentNonProdEnv();
	const isProd = isOnProd();

	if (isNilOrEmpty(currentEnv) || isProd) {
		return null;
	}

	return (
		<Box
			sx={{
				borderRadius: (theme) => theme.shape.borderRadius,
				backgroundColor: 'primary.main',
				mr: 1,
				border: 'solid 3px',
				borderColor: 'primary.main',
			}}
		>
			<Stack direction="row">
				<Typography
					variant="body2"
					sx={{
						px: 0.5,
					}}
				>
					Test
				</Typography>
				<Box
					sx={{
						px: 0.5,
						borderRadius: (theme) => theme.shape.borderRadius,
						backgroundColor: 'primary.dark',
					}}
				>
					<Typography variant="body2">{currentEnv}</Typography>
				</Box>
			</Stack>
		</Box>
	);
};

export default Environment;
